export const ISLOGGEDIN = "ISLOGGEDIN";
export const ONLOGOUT = "ONLOGOUT";
export const LOGINUSER = "LOGINUSER";
export const LOGINAFTERTOKENEXPIRY = "LOGINAFTERTOKENEXPIRY";